export const AVATARS = {
  MALE: '/avatars/male.webp',
  FEMALE: '/avatars/female.webp'
};